import React from 'react'
import ImageDebugTest from '../components/test/ImageDebugTest'

const ImageDebugTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ImageDebugTest />
    </div>
  )
}

export default ImageDebugTestPage